module.exports = __webpack_public_path__ + "static/media/ImageSymbol_ai.0bd37d31.zip";